import React, { memo } from 'react';
import styled from 'styled-components';

import type { BlockJobOpeningsFragment } from '../schemas/api';

import useInview from '../hooks/useInview';

import { staggerChildrenFadeTranslateIn } from '../styles/animations';
import TYPO from '../styles/typography';
import COLORS from '../styles/colors';
import { Grid, columns } from '../styles/grid';

import * as textUtils from '../utils/text';
import useExternalScript from '../hooks/useExternalScript';

const Container = styled(Grid)`
  padding: 72px 12px;

  @media (min-width: 960px) {
    padding: 120px 12px;
  }
`;

const HeadingSection = styled.div<ContentProps>`
  ${columns(1, 12)}
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: left;
  margin-bottom: 36px;
  ${(props) => staggerChildrenFadeTranslateIn(props.$show)};

  @media (min-width: 768px) {
    ${columns(1, 9)}
  }
  @media (min-width: 960px) {
    ${columns(1, 6)}
  }
`;

const Heading = styled.h1`
  ${TYPO.h2}
  display:flex;
`;

const Subheading = styled.div`
  ${TYPO.p1};
  color: ${COLORS.text.light.css};
  line-height: 148%;
  max-width: 820px;
  white-space: pre-wrap;
  & strong {
    color: ${COLORS.brand.regular.css};
    font-weight: inherit;
  }
`;
type ContentProps = { $show: boolean };
const Content = styled.ul<ContentProps>`
  ${columns(1, 12)};
  display: flex;
  flex-direction: column;
  opacity: ${(props) => (props.$show ? 1 : 0)};
  transition: opacity 0.2s ease;
`;

type CareersOpeningsProps = {
  data: BlockJobOpeningsFragment;
};

function CareersOpeningsEmbedded({ data }: CareersOpeningsProps) {
  const [inViewRef, inView] = useInview({});

  useExternalScript(data.ashbyEmbedScript);

  return (
    <Container id={data.sectionId}>
      <HeadingSection ref={inViewRef} $show={inView}>
        <Heading>{textUtils.highlight(data.heading)}</Heading>
        {data.byline && (
          <Subheading>{textUtils.highlight(data.byline)}</Subheading>
        )}
      </HeadingSection>
      <Content $show={inView}>
        <div id="ashby_embed" />
      </Content>
    </Container>
  );
}

export default memo(CareersOpeningsEmbedded);
